import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=2bca5bab&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bca5bab')) {
      api.createRecord('2bca5bab', component.options)
    } else {
      api.reload('2bca5bab', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=2bca5bab&", function () {
      api.rerender('2bca5bab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-86KHDcCh95T0h/JS/comp/openstreetmap.vue"
export default component.exports